import type { TenantContext } from '@zhiyue/core';

export const isCurrentTenantAdmin = (
  tenants: TenantContext[],
  currentTenantUuid?: string,
) =>
  Boolean(
    currentTenantUuid &&
      tenants.find((tenant) => tenant.id === currentTenantUuid)?.roleLabel ===
        '管理员',
  );
